/**
 * Only put public interfaces in here
 */
export var FocusLayerSizeV2;
(function (FocusLayerSizeV2) {
    FocusLayerSizeV2["A"] = "A";
    FocusLayerSizeV2["B"] = "B";
    FocusLayerSizeV2["C"] = "C";
    FocusLayerSizeV2["NONE"] = "NONE";
})(FocusLayerSizeV2 || (FocusLayerSizeV2 = {}));
export var InteractionLayerSizeV2;
(function (InteractionLayerSizeV2) {
    InteractionLayerSizeV2["A"] = "A";
    InteractionLayerSizeV2["B"] = "B";
    InteractionLayerSizeV2["C"] = "C";
    InteractionLayerSizeV2["D"] = "D";
    InteractionLayerSizeV2["E"] = "E";
})(InteractionLayerSizeV2 || (InteractionLayerSizeV2 = {}));
export var ShimBackgroundTypeV2;
(function (ShimBackgroundTypeV2) {
    ShimBackgroundTypeV2["OPAQUE"] = "OPAQUE";
    ShimBackgroundTypeV2["TRANSPARENT"] = "TRANSPARENT";
})(ShimBackgroundTypeV2 || (ShimBackgroundTypeV2 = {}));
export var DisclaimerLayerAppearanceV2;
(function (DisclaimerLayerAppearanceV2) {
    DisclaimerLayerAppearanceV2["DARK"] = "DARK";
    DisclaimerLayerAppearanceV2["LIGHT"] = "LIGHT";
})(DisclaimerLayerAppearanceV2 || (DisclaimerLayerAppearanceV2 = {}));
//# sourceMappingURL=types.js.map